module.exports = __webpack_public_path__ + "img/customers.ab8fd03d.png";